module.exports = __webpack_public_path__ + "img/msdt3.edad4559.png";